import { Card } from '@systhemaui/next'
import { cn } from '@systhemaui/next'

interface AuthCardProps {
  children: React.ReactNode
  className?: string
}

export default function AuthCard({ children, className }: AuthCardProps) {
  return (
    <Card disableAnimation className={cn('w-full', className)}>
      {children}
    </Card>
  )
}
